import { fetchUserAttributes } from 'aws-amplify/auth';
import { createAppAsyncThunk } from '../appAsyncThunk';
import { get, post, ApiError } from 'aws-amplify/api';
import { uploadFileThunk } from '../general/thunks';
import { setIncompleteProfileModal } from './slice';
import { downloadData } from 'aws-amplify/storage';
import { setNotification } from '../general/slice';
import { JobSearchParams } from './types';

export const getProfileDataThunk = createAppAsyncThunk(
    'workspace/getProfileDataThunk', async (_, { dispatch }) => {
        try {
            const restOperation = await get({
                apiName: 'emrProfile',
                path: '/emrProfile/{proxy+}',
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (error: unknown) {
            if (error instanceof ApiError) {
                if (error.response && error.response.statusCode === 405) {
                    const { body } = error.response;
                    if (body) {
                        const bodyObj = JSON.parse(body);
                        if (('profile' in bodyObj && bodyObj.profile === 'inComplete') || 'cognito' in bodyObj) {
                            dispatch(setIncompleteProfileModal(true));
                        }
                    }
                }
            }
        }
    });

export const getLogoImageThunk = createAppAsyncThunk(
    'workspace/getLogoImageThunk', async (key: string) => {
        const downloadResult = await downloadData({
            key: `companies-logo-images/${key}`,
            options: {
                accessLevel: 'guest',
            }
        }).result;

        const blob = await downloadResult.body.blob();
        const ObjectURL = URL.createObjectURL(blob);
        return ObjectURL;
    });

export const getUserAttributesThunk = createAppAsyncThunk(
    'workspace/getUserAttributesThunk', async () => {
        const userAttributes = await fetchUserAttributes();
        return userAttributes;
    });

export const postNewJobThunk = createAppAsyncThunk(
    'workspace/postNewJobThunk', async (body: any, { dispatch }) => {
        const { files, ...rest } = body;

        const restOperation = await post({
            apiName: 'emrJob',
            path: '/emrJob/{proxy+}',
            options: { body: rest }
        }).response;

        const response: any = await restOperation.body.json();

        await dispatch(keywordExtractorThunk({
            job_id: response.job_id,
            top_n: 10
        }));

        files.forEach((file: File) => {
            dispatch(uploadFileThunk({ file: file, fileName: `${rest.id}/${response.job_id}/${file.name}`, accessLevel: 'private' }));
        });

        dispatch(examGeneratorThunk({
            job_id: response.job_id,
            n_questions: 40,
            codingExam: rest.codingExam,
            multipleChoiceExam: rest.multipleChoiceExam,
            recruitingInterview: rest.recruitingInterview,
        }));

        return response;
    });

export const getJobDescriptionFromAIThunk = createAppAsyncThunk(
    'workspace/getJobDescriptionFromAIThunk', async (body: any) => {
        const restOperation = post({
            apiName: 'emrKeywordExtractor',
            path: '/emrKeywordExtractor/{proxy+}',
            options: { body }
        });

        const response = await restOperation.response;
        return response.body.json();
    });

export const keywordExtractorThunk = createAppAsyncThunk(
    'workspace/keywordExtractorThunk', async (body: any) => {
        const restOperation = post({
            apiName: 'emrKeywordExtractor',
            path: '/emrKeywordExtractor/{proxy+}',
            options: { body }
        });

        const response = await restOperation.response;
        return response.body.json();
    });

export const examGeneratorThunk = createAppAsyncThunk(
    'workspace/examGeneratorThunk', async (body: any) => {
        const restOperation = post({
            apiName: 'emrExamGenerator',
            path: '/emrExamGenerator/{proxy+}',
            options: { body }
        });

        const response = await restOperation.response;
        return response.body.json();
    });

export const getJobsThunk = createAppAsyncThunk(
    'workspace/getJobsThunk', async (params: JobSearchParams) => {
        const queryParams: Record<string, string> = {};
        if (params.search) queryParams.search = params.search;
        if (params.city) queryParams.city = params.city;
        if (params.sort) queryParams.sort = params.sort;

        const restOperation = await get({
            apiName: 'emrJob',
            path: '/emrJob/{proxy+}',
            options: { queryParams }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const getJobDetailThunk = createAppAsyncThunk(
    'workspace/getJobDetailThunk', async (queryParams: any) => {
        const restOperation = await get({
            apiName: 'emrJob',
            path: '/emrJob/{proxy+}',
            options: { queryParams }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const getExaminersThunk = createAppAsyncThunk(
    'workspace/getExaminersThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrStatistics',
            path: '/emrStatistics/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const endExamThunk = createAppAsyncThunk(
    'workspace/endExamThunk', async (body: any) => {

        const restOperation = await post({
            apiName: 'emrEndExam',
            path: '/emrEndExam/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const getExaminerProfileThunk = createAppAsyncThunk(
    'workspace/getExaminerProfileThunk', async (params: any, { rejectWithValue }) => {
        try {

            const restOperation = await get({
                apiName: 'emeProfile',
                path: '/emeProfile/{proxy+}',
                options: { queryParams: { id: params.id, job: params.jobId } }
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const updateExaminersStatusThunk = createAppAsyncThunk(
    'workspace/updateExaminersStatusThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'emrStatus',
                path: '/emrStatus/{proxy+}',
                options: { body },
            }).response;

            dispatch(setNotification(['Examiners status updated successfully', 'success']));
            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const getPaymentMethodsThunk = createAppAsyncThunk(
    'workspace/paymentThunk', async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'emrPayment',
                path: '/emrPayment/{proxy+}',
                options: { body },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const purchasePaymentThunk = createAppAsyncThunk(
    'workspace/purchasePaymentThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrPayment',
            path: '/emrPayment/{proxy+}',
            options: { body },
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const attachPaymentMethodThunk = createAppAsyncThunk(
    'workspace/attachPaymentMethodThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrPayment',
            path: '/emrPayment/{proxy+}',
            options: { body },
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const getStripeCustomerThunk = createAppAsyncThunk(
    'workspace/getStripeCustomerThunk', async (body: any) => {
        try {
            const restOperation = await post({
                apiName: 'emrPayment',
                path: '/emrPayment/{proxy+}',
                options: { body },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            console.log(e);
        }
    });

export const getTransactionsHistoryThunk = createAppAsyncThunk(
    'workspace/getTransactionsHistoryThunk', async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'emrPayment',
                path: '/emrPayment/{proxy+}',
                options: { body },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const getSubsciptionHistoryThunk = createAppAsyncThunk(
    'workspace/getSubsciptionHistoryThunk', async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'emrPayment',
                path: '/emrPayment/{proxy+}',
                options: { body },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const deletePaymentMethodThunk = createAppAsyncThunk(
    'workspace/deletePaymentMethodThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'emrPayment',
                path: '/emrPayment/{proxy+}',
                options: { body },
            }).response;

            await dispatch(getPaymentMethodsThunk({
                id: body.id,
                action: 'get_payment_methods',
            }));

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const updateProfileInfoThunk = createAppAsyncThunk(
    'workspace/updateProfileInfoThunk', async (body: any, { dispatch }) => {

        const restOperation = post({
            apiName: 'emrProfile',
            path: '/emrProfile/{proxy+}',
            options: { body }
        });

        const response = await restOperation.response;
        // dispatch(getProfileDataThunk(body.id));
        dispatch(getProfileDataThunk());
        return response.body.json();
    });

export const sendSupportMessageThunk = createAppAsyncThunk(
    'workspace/sendSupportMessageThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {
            const restOperation = post({
                apiName: 'emrSupport',
                path: '/emrSupport/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            dispatch(setNotification(['Message sent successfully', 'success']));
            return response.body.json();
        } catch (e: unknown) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const getExamFilesThunk = createAppAsyncThunk(
    'workspace/getExamFilesThunk', async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = post({
                apiName: 'getUrl',
                path: '/getUrl/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            const resJson: any = await response.body.json();
            return resJson?.url as any;
        } catch (e: unknown) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const requestChangePlanThunk = createAppAsyncThunk(
    'workspace/requestChangePlanThunk', async (body: any, { dispatch, rejectWithValue }) => {
        const baseUrl = process.env.REACT_APP_SUPPORT_API_BASE_URL || '';
        const response = await fetch(baseUrl, {
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (response.ok) {
            dispatch(setNotification(['Message sent successfully', 'success']));
            return response;
        } else {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const getRecruitingInterviewQuestionsThunk = createAppAsyncThunk(
    'workspace/getRecruitingInterviewQuestionsThunk', async (_, { rejectWithValue }) => {
        try {

            const restOperation = await get({
                apiName: 'emrInterview',
                path: '/emrInterview/{proxy+}',
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const sendMemberInvitationThunk = createAppAsyncThunk(
    'workspace/sendMemberInvitationThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrInvite',
            path: '/emrInvite/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const updateInvitedMemberInfoThunk = createAppAsyncThunk(
    'workspace/updateInvitedMemberInfoThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrInvite',
            path: '/emrInvite/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const leaveOrganizationThunk = createAppAsyncThunk(
    'workspace/leaveOrganizationThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrInvite',
            path: '/emrInvite/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const applyReferralCodeThunk = createAppAsyncThunk(
    'workspace/applyReferralCodeThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrPayment',
            path: '/emrPayment/{proxy+}',
            options: { body },
        }).response;

        const response = restOperation;
        return response as any;
    });

export const resetUserEmailOrPhoneThunk = createAppAsyncThunk(
    'workspace/resetUserEmailOrPhoneThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrResetUser',
            path: '/emrResetUser/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const paymentThunk = createAppAsyncThunk(
    'workspace/paymentThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrPayment',
            path: '/emrPayment/{proxy+}',
            options: { body },
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const editExamThunk = createAppAsyncThunk(
    'workspace/editExamThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'emrExamEdit',
            path: '/emrExamEdit/{proxy+}',
            options: { body },
        }).response;

        const response = restOperation.body.json();
        return response as any;
    });

export const editJobThunk = createAppAsyncThunk(
    'workspace/editJobThunk', async (body: any) => {

        const restOperation = await post({
            apiName: 'emrJob',
            path: '/emrJob/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response;
    });

export const finalizeApplicantExamStatusThunk = createAppAsyncThunk(
    'workspace/finalizeApplicantExamStatusThunk', async (body: any) => {

        const restOperation = await post({
            apiName: 'emrFinalize',
            path: '/emrFinalize/{proxy+}',
            options: { body }
        }).response;

        const response = restOperation.body.json();
        return response;
    });